<template>
  <div>
    <div
      class="custom-loading"
      :class="isFullScreen ? 'custom-loading-component-full' : 'custom-loading-component'"
      :style="{ display: show ? 'block' : 'none' }"
    >
      <component v-if="parsNoTitleLogoComponent" :is="parsNoTitleLogoComponent" class="mt-10" />
      <div class="centered" v-else>
        <img src="@/assets/images/logo-loading.gif" class="loading-logo" width="125" height="131" alt="" />
        <div class="btn-div" v-if="showCancelButton">
          <v-icon class="cancel-btn" @click="cancelLoading"> mdi-close</v-icon>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import constant from "../main.constants";
import { loadComponent } from "@/helpers/separateLoaderEnvHelper";

export default {
  name: "custom-loading",
  props: {
    show: Boolean,
    showCancelButton: Boolean,
    isFullScreen: { type: Boolean, default: true }, //TODO: Partial olarak kullanılabilecek hale getirilmeli.
  },
  watch: {
    show(newValue) {
      if (newValue) {
        // setTimeout kullanılmamalı.
        //b-overlay kaldırıldığı için b-overlay'in show ve shown attributelarındaki delayi sağlamak için kullanıldı.
        this.shownEmitTimeout = setTimeout(() => {
          this.$emit("shown");
          this.shownEmitTimeout = null;
        });
      }
    },
  },
  data() {
    return {
      overlayClass: "",
      shownEmitTimeout: null,
      parsNoTitleLogoComponent: null,
    };
  },
  async created() {
    await this.loadParsNoTitleLogoComponent();
  },
  beforeDestroy() {
    this.clearShownTimeout();
  },
  methods: {
    async loadParsNoTitleLogoComponent() {
      try {
        const component = await loadComponent(constant.ENV_COMPONENTS.BOVERLAY_PARSNOTITLELOGO);
        if (component) {
          this.parsNoTitleLogoComponent = component.default || component;
        }
      } catch (error) {
        console.error("ParsNoTitleLogo component yüklenemedi:", error);
      }
    },
    clearShownTimeout() {
      if (this.shownEmitTimeout) {
        clearTimeout(this.shownEmitTimeout);
        this.shownEmitTimeout = null;
      }
    },
    cancelLoading() {
      this.$emit("cancelLoading");
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-loading-component-full {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.custom-loading-component {
  position: absolute;
  width: 100%;
  height: 100%;
}

.custom-loading {
  z-index: 2147483647;
  background-color: rgba(255, 255, 255, 0.812);
}

.centered {
  width: 125px;
  height: 131px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loading-logo {
  display: block;
  width: 100%;
  height: auto;
}
.btn-div {
  position: absolute;
  right: 0;
  bottom: 100%;
  margin-bottom: 8px;
}
.cancel-btn {
  color: white;
  background-color: #00a7e1 !important;
  border-radius: 100px;
}
</style>
